import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import MOCK_DATA from './rateController.json';

const queryRateInfo = (req, res, ctx) => {
  const responseData = MOCK_DATA['rateController/queryRateInfo'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

export const handlers = [
  rest.post(getApiEndpoint('rateController/queryRateInfo'), withScenario(withAuthCheck(queryRateInfo))),
];
